import { IAgentResponse } from "../../types/api/agent";
import { IAgent } from "../../types/agent";
import { toFrontendStatus } from "./agent-status-converter";
import { parsePhoneNumber } from "react-phone-number-input";

export function toFrontendAgent(agent: IAgentResponse): IAgent {
  const country = agent.phoneNumber
    ? parsePhoneNumber(agent.phoneNumber)?.country || "US"
    : "US";
  return {
    id: agent.id,
    name: agent.name,
    slug: agent.slug,
    type: agent.type,
    status: toFrontendStatus({
      enabled: agent.enabled,
      pausedUntil: agent.pausedUntil,
      panic: agent.panic,
    }),
    phoneNumber: agent.phoneNumber,
    address: agent.formattedAddress,
    timezone: agent.timezone,
    country: country,
    posProvider: agent.posProvider,
  };
}
